import { useFormContext } from 'react-hook-form';

import { SubmitSuccessHandlerFn } from '../types';
import { formStateSchema } from '../schemas';
import { UNKNOWN_ERROR_MESSAGE } from '../constants';

export const useHandleSubmit = (onSuccess: SubmitSuccessHandlerFn) => {
  const { handleSubmit, setError } = useFormContext();

  return handleSubmit((formState: unknown) => {
    try {
      onSuccess(formStateSchema.parse(formState));
    } catch (e) {
      setError('root', { message: UNKNOWN_ERROR_MESSAGE });
    }
  });
};
